export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_00.6eb5267c.png";